var TOUCH_HEIGHT = '3rem';
var NON_TOUCH_HEIGHT = '3.5rem';
var SIDE_NAV_CLOSED_WIDTH = '3.5rem';
var SIDE_NAV_OPENED_WIDTH = '15rem';
var FOOTER_HEIGHT = '3.5rem';

export { FOOTER_HEIGHT, NON_TOUCH_HEIGHT, SIDE_NAV_CLOSED_WIDTH, SIDE_NAV_OPENED_WIDTH, TOUCH_HEIGHT };
//# sourceMappingURL=SideNavigation.constants.js.map
